import { render } from "./OpportunityStandardSearch.vue?vue&type=template&id=fea5b6be"
import script from "./OpportunityStandardSearch.vue?vue&type=script&lang=js"
export * from "./OpportunityStandardSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__